import React, { useContext, useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  VStack,
  Link,
  Icon,
  Divider,
  Box,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaInstagram } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { AppContext } from '../context/AppContext';

const MotionVStack = motion(VStack);
const MotionBox = motion(Box);

const InstagramModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { userEmail } = useContext(AppContext);
  useEffect(() => {
    if (!userEmail) return;
    const lastShownDate = localStorage.getItem(`instagram_modal_last_shown_${userEmail}`);
    const today = new Date().toDateString();

    if (lastShownDate !== today) {
      setIsOpen(true);
    }
  }, [userEmail]);

  const handleClose = () => {
    if (!userEmail) return;
    const today = new Date().toDateString();
    localStorage.setItem(`instagram_modal_last_shown_${userEmail}`, today);
    setIsOpen(false);
    window.location.href = "https://www.instagram.com/durgeshsingh_ctrader?igsh=MThsMDlpczBlbTJ3aw==";
  };

  const handleFollowClick = () => {
    // You can add logic here if you want to track the click before closing
  };

  const bgColor = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.800', 'white');

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
      },
    },
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="xl" isCentered>
      <ModalOverlay backdropFilter="blur(5px)" />
      <ModalContent bg={bgColor} color={textColor} borderRadius="xl">
        <ModalHeader textAlign="center">Connect With Us</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <MotionVStack
            spacing={3}
            align="stretch"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {/* English Section */}
            <MotionBox variants={itemVariants}>
              <Text fontWeight="bold" fontSize="md" mb={1}>
                Hello!
              </Text>
              <Text fontSize="sm">
                You can follow our website team specialist on Instagram using the provided ID. If support is ever unavailable, feel free to contact them directly—they respond promptly. For any issues or business-related discussions, you can reach out to them on Instagram. Thank you!
              </Text>
            </MotionBox>

            <MotionBox variants={itemVariants}>
              <Divider />
            </MotionBox>

            {/* Hindi Section */}
            <MotionBox variants={itemVariants}>
              <Text fontWeight="bold" fontSize="md" mb={1}>
                नमस्ते!
              </Text>
              <Text fontSize="sm">
                आप हमारे वेबसाइट टीम विशेषज्ञ को दिए गए इंस्टाग्राम आईडी से फॉलो कर सकते हैं। यदि कभी सपोर्ट उपलब्ध न हो, तो आप उन्हें सीधे संपर्क कर सकते हैं—वे तुरंत जवाब देते हैं। किसी भी समस्या या व्यवसाय से जुड़े चर्चा के लिए, आप उन्हें इंस्टाग्राम पर संपर्क कर सकते हैं। धन्यवाद!
              </Text>
            </MotionBox>

            {/* Combined Call to Action */}
            <MotionBox textAlign="center" pt={1} variants={itemVariants}>
              <Text fontSize="sm" fontWeight="semibold">
                Follow us on Instagram to always stay connected with our latest updates and content. <Link href="https://www.instagram.com/durgeshsingh_ctrader?igsh=dW5penI1bjA4OGVv&utm_source=qr" isExternal color="blue.500" onClick={handleFollowClick}>Click here!</Link>
              </Text>
              <Text fontSize="sm" fontWeight="semibold" mt={1}>
                आप हमें इंस्टाग्राम पर फॉलो करें, ताकि आप हमारे नवीनतम अपडेट्स और कंटेंट से हमेशा जुड़े रहें। <Link href="https://www.instagram.com/durgeshsingh_ctrader?igsh=dW5penI1bjA4OGVv&utm_source=qr" isExternal color="blue.500" onClick={handleFollowClick}>Click here!</Link>
              </Text>
              <Link href="https://www.instagram.com/durgeshsingh_ctrader?igsh=dW5penI1bjA4OGVv&utm_source=qr" isExternal onClick={handleFollowClick} display="inline-block" mt={2}>
                <MotionBox
                  display="inline-block"
                  whileHover={{ scale: 1.2, rotate: 10 }}
                  animate={{
                    scale: [1, 1.1, 1],
                    rotate: [0, 5, -5, 0],
                  }}
                  transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut"
                  }}
                >
                  <Icon as={FaInstagram} w={10} h={10} color="pink.500" />
                </MotionBox>
              </Link>
            </MotionBox>
          </MotionVStack>
        </ModalBody>

        <ModalFooter justifyContent="center">
          <Button  colorScheme="blue" onClick={handleClose} size="lg" w="full">
            OK, i Followed
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default InstagramModal;
